import {observable} from 'mobx';
import {IObservableSession} from '@techsee/techsee-client-infra/lib/services/UserService';

export type InviteMobileUser = Record<string, unknown>;
export type InviteMobileAccountData = Record<string, unknown>;

export class InviteMobileState {
    @observable currentUser?: InviteMobileUser;
    @observable accountData?: InviteMobileAccountData;
    @observable statusMessage?: string;
    @observable message?: string;
    @observable customError?: {message: string; level?: string};
    @observable inviteMethod?: string;
    @observable sessionType?: string;
    @observable selectedLanguage?: string;
    @observable customerId: string = '';
    @observable phone: string = '';
    @observable meetingCode: string = '';
    @observable observedRoomId: string = '';
    @observable technicianRoomId: string = '';
    @observable sms: boolean = false;
    @observable showMobileTechseeInvite: boolean = true;
    @observable enableAudio: boolean = false;
    @observable countryCodeText: string = '';
    @observable isOverlayOpen: boolean = false;

    @observable activeTechnicians: Array<Record<string, unknown>> = [];
    @observable observableUsers: IObservableSession[] = [];

    constructor(currentUser?: InviteMobileUser, accountData?: InviteMobileAccountData) {
        this.currentUser = currentUser;
        this.accountData = accountData;
    }
}
